import { createSelector } from "reselect"
import { isChangeFlightsEnabledSelector } from "@kiwicom/frontend-common/services/branding/services"
import { bookingDataSelector } from "@kiwicom/frontend-common/services/booking/booking"
import { equals } from "ramda"
import { FORM_FIELDS } from "@kiwicom/frontend-common/consts/form"
import type { FormFieldType } from "@kiwicom/frontend-common/consts/form"

import {
  CABIN_TYPE_MIXED_ALLOWED_DEFAULT,
  MAX_TRAVEL_DURATION_DEFAULT,
  TRANSPORT_TYPES_DEFAULT,
} from "../../scenes/BookingJourneyChange/components/ChangeAlternatives/Filters/consts"
import type { TransportType } from "../../scenes/BookingJourneyChange/components/ChangeAlternatives/Filters/TransportTypeFilter"
import type { CabinType } from "../../scenes/BookingJourneyChange/components/ChangeAlternatives/Filters/CabinTypeFilter"

export const isAllowedToChangeFlightsSelector = createSelector(
  [isChangeFlightsEnabledSelector, bookingDataSelector],
  // @ts-expect-error: Flow to TS migration.
  (isChangeFlightsEnabled, booking) => isChangeFlightsEnabled && booking.canChangeFlights(),
)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const itineraryChangeFormFieldSelector = (state: any) => (fieldName: FormFieldType) =>
  state.changeFlights.form.fields[fieldName]

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initialCabinTypeSelector = (state: any): CabinType => {
  const journey = state.changeFlights.selected
  const cabinClasses = journey.fareCategoryTypes()
  if (cabinClasses.includes("F")) {
    return "firstClass"
  }
  if (cabinClasses.includes("C")) {
    return "business"
  }
  if (cabinClasses.includes("W")) {
    return "premiumEconomy"
  }
  return "economy"
}

const transportTypesChanged = (transportTypes: TransportType[]) =>
  !equals(new Set(transportTypes), new Set(TRANSPORT_TYPES_DEFAULT))

const cabinTypeChanged = (cabinType: CabinType, defaultCabinType: CabinType, cabinMixed: boolean) =>
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  (cabinType && cabinType !== defaultCabinType) || cabinMixed !== CABIN_TYPE_MIXED_ALLOWED_DEFAULT

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const activeFilterCountSelector = (state: any) => {
  const transportTypes = itineraryChangeFormFieldSelector(state)(FORM_FIELDS.TRANSPORT_TYPES)
  const cabinType = itineraryChangeFormFieldSelector(state)(FORM_FIELDS.CABIN_TYPE)
  const cabinMixed = itineraryChangeFormFieldSelector(state)(FORM_FIELDS.CABIN_TYPE_MIXED_ALLOWED)
  const maxTravelDuration = itineraryChangeFormFieldSelector(state)(FORM_FIELDS.MAX_TRAVEL_DURATION)
  const initialCabinType = initialCabinTypeSelector(state)

  let filterCount = 0
  if (transportTypesChanged(transportTypes)) {
    filterCount += 1
  }
  if (cabinTypeChanged(cabinType, initialCabinType, cabinMixed)) {
    filterCount += 1
  }
  if (maxTravelDuration !== MAX_TRAVEL_DURATION_DEFAULT) {
    filterCount += 1
  }
  return filterCount
}
